export default "__VITE_ASSET__c0d64e0b__"